import { render, staticRenderFns } from "./mainIndex.vue?vue&type=template&id=c9d45bc2&scoped=true&"
import script from "./mainIndex.vue?vue&type=script&lang=js&"
export * from "./mainIndex.vue?vue&type=script&lang=js&"
import style0 from "./mainIndex.vue?vue&type=style&index=0&id=c9d45bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d45bc2",
  null
  
)

export default component.exports